<template>
    <div v-if="componentData && componentData.images?.data?.length" class="image-wrapper grid two GridImages">
        <div v-for="(image, index) in componentData.images.data" :key="index">
            <SafeImage 
                :imageData="{ data: image }"
                :alt="image.attributes?.alternativeText || `Gallery image ${index + 1}`"
                :placeholder="PLACEHOLDER_IMAGES.GENERAL"
                placeholderText="Gallery image not available"
            />
        </div>
    </div>
    <div v-else class="image-wrapper grid two GridImages">
        <div class="no-images-message">
            <p>No images available for this gallery.</p>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent, PropType } from 'vue'
import SafeImage from '../SafeImage.vue'
import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

export default defineComponent({
    components: {
        SafeImage
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl,
            PLACEHOLDER_IMAGES
        };
    }
})

</script>

<style scoped>
.no-images-message {
    grid-column: 1 / -1;
    text-align: center;
    padding: 2rem;
    color: #6b7280;
    font-style: italic;
}
</style>
